import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=1906d0dc&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=js&"
export * from "./Experience.vue?vue&type=script&lang=js&"
import style0 from "./Experience.vue?vue&type=style&index=0&id=1906d0dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906d0dc",
  null
  
)

export default component.exports